import { ENV } from '@/config/env';
import { dealWatchdogLogParams } from '@hll/eapp-utils';
import watchdog from '@hll/watch-dog-jsutil';

const myConsole: any = {};
const showLog = localStorage.getItem('showLog');

Object.keys(console).forEach((fnName: any) => {
  myConsole[fnName] = (...params: any) => {
    try {
      const argsArr = Array.from(params);
      const eventName = argsArr[0] as string;
      const restField = argsArr.slice(1) as string[];
      const logArr = dealWatchdogLogParams(restField);

      if (ENV !== 'prod' || showLog) {
        console.log(...params);
      }
      watchdog.sendEvent(eventName, ...logArr);
    } catch (err) {
      console.log('上报日志错误', err);
    }
  };
});

export const log = myConsole;
